<template>
  <v-card height="100%" style="padding-top:15%">
    <v-card-title class="justify-center display-2" >Whoops, 404</v-card-title>
    <v-card-subtitle class="text-center">The page you were looking for does not exist</v-card-subtitle>
    <v-card-actions class="justify-center">
      <v-btn outlined color="blue" @click="refresh">Get me out of here!</v-btn>
    </v-card-actions>
  </v-card>
</template> 
<script>
export default {
  methods: {
    refresh() {
      this.$router.push({ path: `/` });
    }
  }
};
</script>